export default __webpack_public_path__ + "static/media/001.7bc19588.jpg";